//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var BASE_URL = '/prototype/accounting/dashboard';

export default {
    data: function data() {
        return {
            apChartData: [],
            arChartData: [],
            cashChartData: [],
            incomeChartData: [],
            expenseChartData: [],
            glChartData: {
                headers: ["Account Name", "Account #", { title: 'Last Updated', filter: 'dateFull' }, { title: 'Balance', filter: 'toCurrency' }],
                fields: ["name", "number", "date", "balance"],
                items: []
            }
        };
    },
    created: function created() {
        Event.$on('view-account', function (item, idx) {
            Event.$emit('show-flyout', 'Account Details', '', 'gl-account-details', item);
        });
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('view-account');
    },
    mounted: function mounted() {
        var _this = this;

        // get A/P Chart
        axios.post(BASE_URL + "/ap").then(function (response) {
            return _this.apChartData = response.data;
        });

        // get A/R Chart
        axios.post(BASE_URL + "/ar").then(function (response) {
            return _this.arChartData = response.data;
        });

        // get Cash Chart
        axios.post(BASE_URL + "/cash").then(function (response) {
            return _this.cashChartData = response.data;
        });

        // get Income Chart
        axios.post(BASE_URL + "/income").then(function (response) {
            return _this.incomeChartData = response.data;
        });

        // get Expense Chart
        axios.post(BASE_URL + "/expenses").then(function (response) {
            return _this.expenseChartData = response.data;
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/accounting/AccountingDashboard.vue
// module id = bEZL
// module chunks = 0 1